import type { EacMethod } from '@/lib/utils';

/** Chart series label for an EAC method. */
export function getEacChartLabel(method: EacMethod): string {
  return method === 'simple'
    ? 'EAC (Simple)'
    : method === 'performance-based'
      ? 'EAC (CPI)'
      : 'EAC (Re-estimate)';
}

/** Short badge text for an EAC method. */
export function getEacBadgeText(method: EacMethod): string {
  return method === 'simple'
    ? 'Simple'
    : method === 'performance-based'
      ? 'CPI'
      : 'Re-estimate';
}
